<template>
  <div class="stage lg:shadow-lg overflow-hidden rounded">
    <div
      class="flex flex-nowrap transition-transform"
      :style="`transform: translateX(${current * -100}%)`"
    >
      <CarouselItem
        v-for="(item, index) in items"
        :key="`carousel-item-${index}`"
        v-bind="item"
        class="flex-grow"
        @next="$emit('next')"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import CarouselItem from '@/modules/InformationPages/Training/components/Carousel/CarouselItem.vue';

export default defineComponent({
  name: 'Stage',
  components: {
    CarouselItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    current: {
      type: Number,
      default: 0,
    },
  },
  setup() {},
});
</script>

<style scoped>
@media screen and (max-width: 870px) {
  .stage {
    width: 100%;
  }
}
@media screen and (min-width: 870px) {
  .stage {
    width: 863px;
  }
}
</style>
